<template>
  <div class="steps-container">
    <b-steps :active="activeStep" small>
      <b-step title="Step 1" description="Select Items"></b-step>
      <b-step title="Step 2" description="Review Selection"></b-step>
      <b-step title="Step 3" description="Submit"></b-step>
    </b-steps>
  </div>
</template>

<script>
export default {
  name: "Steps",
  props: {
    activeStep: {
      type: Number,
      required: true,
    },
  },
};
</script>
